export const defaultConfiguration = {
    atlas_version: 'v1.0.0'
  }